module.exports = md5;